class Clipboard {
  value = $state()
}

export const clipboard = new Clipboard()

$inspect(clipboard.value)
